import { render } from "./management.cattle.io.roletemplate.vue?vue&type=template&id=2086fb3d&scoped=true"
import script from "./management.cattle.io.roletemplate.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.roletemplate.vue?vue&type=script&lang=js"

import "./management.cattle.io.roletemplate.vue?vue&type=style&index=0&id=2086fb3d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2086fb3d"]])

export default __exports__